export const SET_COINS = "SET_COINS";
export const ADD_COINS = "ADD_COINS";
export const FETCH_COINS = "FETCH_COINS";
export const CHANGE_TOPUP_STATE = "CHANGE_TOPUP_STATE";
export const CHANGE_ACTIVATION_STATE = "CHANGE_ACTIVATION_STATE";
